/**
 * 分享紀錄（組織）列表與組織圖共用的小工具。
 * 下線資料欄位大小寫都可能出現（Guid / guid），一律在這裡正規化。
 */

const pick = (x, A, a) => (x && (x[A] != null ? x[A] : x[a])) ?? null;

/** 會員沒填姓名時顯示的字 */
export const UNNAMED = "未命名";

/** 平面清單 → 樹。回傳根節點陣列（找不到上層的都當根） */
export function buildOrgTree(list) {
  if (!Array.isArray(list) || !list.length) return [];
  const map = Object.create(null);
  const nodes = list.map((x, i) => {
    const rawName = (pick(x, "DownlineName", "downlineName") || "").trim();
    const node = {
      guid: pick(x, "Guid", "guid") || `tmp-${i}`,
      parentGuid: pick(x, "ParentGuid", "parentGuid") || null,
      name: rawName || UNNAMED,
      // 沒填姓名：頭像改灰色，跟真的叫這個名字的人分得出來
      unnamed: !rawName,
      email: pick(x, "Email", "email") || "",
      grade: (pick(x, "ReferralGrade", "referralGrade") || "").trim() || "一般會員",
      date: pick(x, "CreatedDate", "createdDate") || "",
      children: [],
    };
    map[node.guid] = node;
    return node;
  });

  const roots = [];
  nodes.forEach((n) => {
    if (n.parentGuid && map[n.parentGuid] && n.parentGuid !== n.guid) map[n.parentGuid].children.push(n);
    else roots.push(n);
  });
  return roots;
}

/** 整棵子樹的人數（不含自己） */
export function countDescendants(node) {
  return (node.children || []).reduce((sum, c) => sum + 1 + countDescendants(c), 0);
}

/** 頭像上的字：名字的第一個字 */
export function initialOf(name) {
  const s = (name || "").trim();
  return s ? Array.from(s)[0].toUpperCase() : "?";
}

/** 名字決定色相：同一個人每次顏色一樣，掃畫面時認得出來。沒填姓名的一律灰色 */
export function avatarStyle(name, unnamed = false) {
  if (unnamed) return { background: "#eeeeee", color: "rgba(0, 0, 0, 0.45)" };
  let hash = 0;
  for (const ch of name || "") hash = (hash * 31 + ch.charCodeAt(0)) % 360;
  return { background: `hsl(${hash}, 62%, 93%)`, color: `hsl(${hash}, 45%, 34%)` };
}

export function isPlainMember(grade) {
  return !grade || grade === "一般會員";
}

/** 搜尋字有沒有出現在這個人的資料裡 */
export function matchesQuery(node, q) {
  const k = (q || "").trim().toLowerCase();
  if (!k) return false;
  return [node.name, node.email, node.grade, node.date].some((f) => String(f || "").toLowerCase().includes(k));
}

const escapeHtml = (s) =>
  String(s ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");

/**
 * 把搜尋字標成 <mark>，給 v-html 用。
 * 名字、信箱是會員自己填的，先跳脫 HTML 再標記，不然名字裡寫 <img onerror=…> 就會被執行。
 */
export function highlight(text, q) {
  const raw = String(text ?? "");
  const k = (q || "").trim();
  if (!k) return escapeHtml(raw);
  // 用原文切，切完每段各自跳脫 —— 先跳脫再找的話，搜「a」會切進 &amp; 裡
  const re = new RegExp(`(${k.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")})`, "ig");
  return raw
    .split(re)
    .map((seg, i) => (i % 2 === 1 ? `<mark>${escapeHtml(seg)}</mark>` : escapeHtml(seg)))
    .join("");
}
